import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY,
    enableAutoRouteTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    enableCorsCorrelation: true,
    maxBatchInterval: 1000, // Adjust as needed
    disableFetchTracking: false, // Enable fetch tracking
  },
});
appInsights.loadAppInsights();

window.onerror = function (message, source, lineno, colno, error) {
  appInsights.trackException({
    exception: error || new Error(message),
    severityLevel: 3, // Error
    properties: {
      source,
      lineno,
      colno,
      error: error ? error.toString() : 'No error object'
    }
  });
}

export default appInsights;
        